import { __assign } from "tslib";
import { connectMediaStore, useMMSelector, useMMDispatchActions, } from './withOwnReduxStore';
import { setCurrentTierId, unsetCurrentTierId } from '../actions';
import { getCurrentTierId, getCurrentTier } from '../selectors';
export var useCurrentTier = function () { return (__assign(__assign({}, useMMSelector(function (state) { return ({
    currentTierId: getCurrentTierId(state),
    currentTier: getCurrentTier(state),
}); })), useMMDispatchActions({
    setCurrentTierId: setCurrentTierId,
    unsetCurrentTierId: unsetCurrentTierId,
}))); };
export default (function (component) {
    return connectMediaStore(function (state) { return ({
        currentTierId: getCurrentTierId(state),
        currentTier: getCurrentTier(state),
    }); }, {
        setCurrentTierId: setCurrentTierId,
        unsetCurrentTierId: unsetCurrentTierId,
    })(component);
}); // redux typings are a bit dumb with generics
//# sourceMappingURL=withCurrentTier.js.map